import DataTable from 'components/Core/DataTable';
import PurchaseOrder from 'lib/Core/Backend/Controllers/PurchaseOrder';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import ReactNotificationAlert from 'react-notification-alert';
import Notify from "../../lib/Utils/Alert";
import { Alert, Col, Row, Progress, ModalHeader, ModalBody, Button, ModalFooter, Modal, Input,Label,FormGroup } from 'reactstrap';
import Utils from 'lib/Utils/Utils';
import { Modal as MuiModal, Backdrop, Fade } from '@mui/material';
import { data } from 'jquery';

const calculateSubTotal = (amount, quantity, fees, discount) => {
  return ((amount * quantity) - ((amount * quantity) * (discount / 100))) + (quantity * fees);
}

const OrderNRTModify = (props) => {
  const { order, token, brands, cardTypes, name, show, progressName, progressShow,toggleModifyDrawer  } = props;
  const [pogressValue, setPogressValue] = useState(null);
  const poCtl = useMemo(() => new PurchaseOrder(token), [token]);
  const purchaseOrderCtl = useMemo(() => new PurchaseOrder(token), [token]);
  const [warningModal, setWarningModal] = useState(false);
  const[modifyModal,setModifyModal] = useState(false);
  const [showButton,setShowButton] = useState(false)
  const toggleWarning = () => setWarningModal(!warningModal);
  const toggleModify = () => setModifyModal(!modifyModal);
  const [okButtonClicked,setOkButtonClicked] = useState(false);
  const [rowData,setRowData] = useState({})
  const [operativeRow, setOperativeRow] = useState({});
  const [quantityValue,setQuantityValue] = useState()
  const dollar = useMemo(() => Intl.NumberFormat('en-US', {
    style: "currency",
    currency: "USD",
  }), []);
  const table = useRef();
  const alert = useRef();
  const [total, setTotal] = useState('');

  const headers = [
    { title: 'Brand', data: 'brandName', searchable: true, sortable: true },
    { title: 'Card Type', data: 'cardType', searchable: true, sortable: true },
    { title: 'SKU', data: 'sku', searchable: true, sortable: true },
    { title: 'Currency', data: 'currency', searchable: true, sortable: true },
    { title: 'Fee', data: 'fee', searchable: true, sortable: true },
    { title: 'Discount', data: 'discount', searchable: true, sortable: true, render: data => data ? Utils.percentFormat(data / 100) : '0.00%' },
    { title: 'Qty', data: 'quantity', searchable: true, sortable: true },
    {title: 'Completed Qty',data:'completedQuantity',searchable: true, sortable: true},
    { title: 'Value', data: 'amount', sortable: true, render: data => data ? dollar.format(data) : 0 },
    { title: 'Subtotal', data: 'subtotal', sortable: true, render: data => data ? dollar.format(data) : 0 },
    {
        title: 'Action',
        data: 'subtotal',
        sortable:false,
        render: (data, _, rowData) => {
          const dropdownOptions = generateDropdownOptions(data);
  
          // Render the dropdown
          return `
          <div class="d-flex justify-content-center w-100">
          <div class="main_class">
          <p><span></span><span></span><span></span></p>
          
          <select onchange="{() => handleMainDropdownChange}" class="dropdown_value" style="width:20px;cursor:pointer">
           ${dropdownOptions.map((option) => (
  
            `<option value="${option.value}" data-action="${option.action ? option.action.name : ''}">
                    ${option.label}
                  </option>`
          )).join('')}
              </select></div>
        </div>
                
              
                `;
        },
      },
  ];


  function generateDropdownOptions(data) {
    const options = [];
    options.push({
      label: 'Select an action',
      value: 'select_action',
      action: null
    });

    options.push({
      label: 'Modify',
      value: 'modify_details',

    });
    options.push({
      label: "Delete",
      value: "delete"
    })
   

    return options;
  };


  const handleMainDropdownChange = (selectedValue, row) => {
   if(row?.data().quantity === row?.data().completedQuantity){
      Notify(alert,"danger","Order is completed you can not modify")
      return;
    }
    switch (selectedValue) {
      case 'modify_details':
        const rowData = row?.data()
        setRowData(rowData)
        setOperativeRow(row)
        setModifyModal(true)
        setQuantityValue(rowData?.quantity)
        break;
      case 'delete':
        deleteModifyOrder(row)
        break;
       default:
        break;
    }
  }


  const onDraw = () => {
    if (table.current) {
      if (table.current.dataTable.rows().data()) {
        let total = table.current.dataTable.rows().data()
          .reduce((a, b) => {
            return a + b.subtotal;
          }, 0);

        setTotal(dollar.format(total));
      } else {
        setTotal('$0.00');
      }
    }
  };

  const progressFunc = () => {
    if(name){
      purchaseOrderCtl.getPogress(name, (data) => {
        if (data && !data.error) {
          setPogressValue(data[0].percentage);
        } else {
          Notify(alert, "danger", data.error);
        }
      });
    }
    
  };

  const progressBar = () => {
    if(progressName){
      purchaseOrderCtl.getPogress(progressName, (data) => {
        if (data && !data.error) {
          setPogressValue(data[0].percentage);
        } else {
          Notify(alert, "danger", data.error);
        }
      });  
    }
   
  };


  const deleteModifyOrder = (row) =>{
    const rowValue = row?.data()
    purchaseOrderCtl.deleteOrder(rowValue?.id,(data)=>{
      if(data && !data.error){
        row.remove().draw();
        Notify(alert,"success","Delete successfully");
        // setShowButton(true)
      }else{
        Notify(alert,"danger",data?.errorMessage ?? data?.error)
      }

    })

    

  }
  useEffect(() => {
    if(order){
        poCtl.purchaseOrderDetail(order?.id, data => {
            if (data?.status === 403) {
              toggleWarning();
              return;
            }
            if (data.error || data.errorMessage) {
              if (data?.error === "Server error response code: 400. Unable to parse response body.") {
      
              } else {
                Notify(alert, "danger", data.errorMessage ?? data.error);
              }
            } else {
              if (table.current) {
                let orderDetails = data.map(detail => {
                  const currencyFormat = new Intl.NumberFormat('en-US', {
                    style: 'currency',
                    currency: order?.currency ?? 'USD'
                  });
                  let card = cardTypes.find(card => card.id === detail.cardTypeId);
                  return {
                    ...detail,
                    brandName: brands.find(brand => brand.id === detail.brandId).name,
                    cardType: card ? card.productName : 'Not Available',
                    sku: card.sku ? card.sku : 'Not Available',
                    subtotal: calculateSubTotal(detail.amount, detail.quantity, detail.fee, detail.discount),
                    currency: order.currency,
                    fee: currencyFormat.format(detail.fee),
                    completedQuantity:detail?.completedQuantity
                  };
                });
                table.current.dataTable.clear().rows.add(orderDetails).draw();
              }
            }
          });
    }
   
  }, [poCtl, order, brands, cardTypes]);

  useEffect(() => {
    progressBar();
  }, [progressShow]);

  useEffect(() => {
    progressFunc();
  }, [show]);

  const modifyorder = () => {

  };

  const buttonApper = () =>{
    if(quantityValue === ""){
      Notify(alert,"danger","Quantity field can not empty or can not accept blank spaces");
      return;
    }
    if(quantityValue == 0){
      Notify(alert,"danger","Quantity field can not be 0");
      return;
    }
    if (quantityValue < 0) {
      Notify(alert, "danger", "Quantity field cannot be negative");
      
      return;
    }
    purchaseOrderCtl.modifyOrder(rowData?.id,quantityValue,(data)=>{
      if(data && !data.error){
        const currentRowData = operativeRow.data();
        currentRowData.subtotal = data.subtotal;
        currentRowData.quantity = data.quantity;
  
        operativeRow.data(currentRowData).draw();
     Notify(alert,"success","Quantity of this order is modified")
     toggleModify();
    //  setShowButton(true)
     setOkButtonClicked(true)
      }else{
        Notify(alert,"danger",data?.errorMessage ?? data?.error)
      }
     })

   
  }

  const handleSubmit = () =>{
   purchaseOrderCtl.completeOrder(order?.id,(data)=>{
      if(data && !data.error){
        Notify(alert,"success","Order process complted successfully")
        // setShowButton(false);
      }else{
        Notify(alert,"danger", data?.errorMessage ?? data?.error)
        setOkButtonClicked(false)
      }
   })
  }

  useEffect(()=>{
    if(toggleModifyDrawer === false && okButtonClicked === true){
    //   setShowButton(false)
    }
    

  },[toggleModifyDrawer])

  return (
    <>
      <ReactNotificationAlert ref={alert} />
      <Row className='justify-content-between m-4'>
        <Col>
          <div>
            <h4>Summary...</h4>
            <div className='table-responsive'>
            <DataTable
              options={{
                paging: false,
                searching: false,
                responsive: true,
                info: false,
                saveState: true,
                drawCallback: onDraw,
              }}
              ref={table}
              data={null}
              columns={headers}
              addmaindropdown={[{ callback: handleMainDropdownChange, selector: 'select.dropdown_value' }]}
             
            />
            </div>
           
          </div>
        </Col>
      </Row>
      <Progress className="my-2 mx-5" value={pogressValue}>
        {pogressValue}%
      </Progress>
      <Row className={ showButton ? 'justify-content-between m-5' :'justify-content-end m-5'}>
      {showButton ? 
     <Col md='4'>
      <Button className="btn btn-primaryTwo" onClick={handleSubmit} style={{height:"45px"}}>Apply & Complete</Button>
      </Col>
     : 
      "" }
        <Col sm='4' className='mr-4'>
          <Alert color='success'>
            <Row className='justify-content-between'>
              <Col sm='3'>Total</Col>
              <Col sm='9'><p className='p-0 m-0 text-right'>{total}</p></Col>
            </Row>
          </Alert>
        </Col>
      </Row>
      
      <Modal isOpen={warningModal} toggle={toggleWarning} backdrop="static">
        <ModalHeader className="bg-warning" toggle={toggleWarning}>Access Denied</ModalHeader>
        <ModalBody>
          <p className="card-just-text">
            You do not have access to perform this action
          </p>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleWarning}>Close</Button>
        </ModalFooter>
      </Modal>

      {/* <Modal isOpen={modifyModal} toggle={toggleModify} backdrop="static"  style={{ zIndex: 99999999 }}>
        <ModalHeader className="bg-info" toggle={toggleModify}>Edit Quantity</ModalHeader>
        <ModalBody>
            <div>
            <p className="card-just-text">
            Enter the quantity you want to change
          </p>
          <FormGroup>
            <Label for='quantity'></Label>
          <Input type='number' id='quantity' placeholder='Enter Quantity' />
          </FormGroup>
          
            </div>
          
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleModify}>Close</Button>
          <Button color="primary" onClick={() => { toggleModify(); buttonApper(); }}>Ok</Button>
        </ModalFooter>
      </Modal> */}

    <MuiModal
        open={modifyModal}
        onClose={toggleModify}
       
        disableEscapeKeyDown
      hideBackdrop={false}
      BackdropProps={{
        style: { transitionDuration: '500ms', backgroundColor: 'rgba(0, 0, 0, 0.5)' },
        onClick: (event) => event.stopPropagation() // Prevent modal close on backdrop click
      }}
        className="custom-modal"
     
      >
        <Fade in={modifyModal}>
        <div className="custom-modal-content">
            <p className="card-just-text" style={{fontSize:"17px",fontWeight:"600"}}>
            Enter the quantity you want to change
          </p>
          <FormGroup>
            <Label for='quantity'></Label>
          <Input type='number' id='quantity' value={quantityValue} onChange={(e)=>setQuantityValue(e.target.value)} placeholder='Enter Quantity' />
          </FormGroup>
          <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '16px' }}>
              <Button onClick={()=> {toggleModify()}} color="secondary" style={{ marginRight: '8px' }}>Close</Button>
              <Button onClick={() =>  buttonApper()} className="btn btn-primaryTwo">Ok</Button>
            </div>
            </div>
            
        </Fade>
      </MuiModal>
    </>
  );
}

export default OrderNRTModify;
